import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "circle-tick.icon",
  "use": "circle-tick.icon-usage",
  "viewBox": "-920 -10856 48.93 48.93",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-920 -10856 48.93 48.93\" id=\"circle-tick.icon\"><path data-name=\"Finished Icon-03\" d=\"M79.865,57.9A24.465,24.465,0,1,0,104.33,82.365,24.471,24.471,0,0,0,79.865,57.9Zm16.514,17L76.96,94.317h0l-.153.153a3.061,3.061,0,0,1-4.332,0l-.153-.153-.153-.153-8.792-8.792a3.261,3.261,0,0,1,0-4.613h0a3.261,3.261,0,0,1,4.613,0l6.626,6.626L91.69,70.311a3.061,3.061,0,0,1,4.332,0l.306.306A3,3,0,0,1,96.379,74.9Z\" transform=\"translate(-975.4 -10913.9)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-tick.icon.svg
// module id = 5ybu
// module chunks = 13